const TimeIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="60"
    height="60"
  >
    <defs>
      <path
        d="M36 12c13.255 0 24 10.745 24 24S49.255 60 36 60 12 49.255 12 36s10.745-24 24-24h0zm0-6C19.43 6 6 19.43 6 36s13.43 30 30 30 30-13.43 30-30A30 30 0 0 0 36 6zm-3 31.23L44.67 48.9a3 3 0 0 0 4.23 0 3 3 0 0 0 0-4.23l-9.9-9.9V24a3 3 0 1 0-6 0v13.23z"
        id="timeA"
      />
    </defs>
    <g transform="translate(-6 -6)" fillRule="evenodd">
      <mask id="timeB" fill="#fff">
        <use xlinkHref="#timeA" />
      </mask>
      <g mask="url(#timeB)" fill="#444560">
        <path d="M0 0h72v72H0z" />
      </g>
    </g>
  </svg>
);

export default TimeIcon;
